const AUTH_CONFIG = {
  domain: 'tg-checkpoint.auth0.com',
  clientId: 'hWTjVeMZlBgyr0depaVbtkTOt91Y40al',
  callbackUrl: `${process.env.REACT_APP_CALLBACK_DOMAIN}/callback`,
  appLogout: 'https://tg-checkpoint.auth0.com/v2/logout',
};

export default AUTH_CONFIG;
